__turbopack_context__.v({
  "className": "jetbrains_mono_52c02e65-module__JeF1va__className",
  "variable": "jetbrains_mono_52c02e65-module__JeF1va__variable",
});
